// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"14f6af05","200":"1e3ffd9b","665":"59aea717","838":"1635129a","979":"6fd8cf32"}[chunkId] + ".chunk.js";
};